import authFetch from './fetch';

export async function fetchBlob(url: string) {
  const response = await authFetch.get({
    url,
  });
  if (!response.ok) {
    throw new Error('Blob fetch failed');
  }
  const blob = await response.blob();
  // const blob = new Blob([blobResponse], { type: blobResponse.type });

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }
  return blob;
}

export function downloadBlob(
  blob: Blob,
  fileName: string,
  download = false,
  target = '_self'
) {
  const link = document.createElement('a');
  link.target = target;
  link.style.position = 'absolute';
  link.style.top = '-10px';
  link.style.left = '-10px';
  link.addEventListener('click', () => {
    const data = URL.createObjectURL(blob);
    if (download) {
      link.href = data;
      link.download = fileName;
    } else if (target === '_blank') {
      window.open(data);
    } else {
      window.location.href = data;
    }
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(data);
    }, 100);
  });
  document.body.appendChild(link);
  link.click();
}
